import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class ParenthesizedExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.ParenthesizedExpression;
    }
    visitNode(sb, expr, options) {
        sb.visit(tsUtils.expression.getExpression(expr), options);
    }
}

//# sourceMappingURL=ParenthesizedExpressionCompiler.js.map
